import { Observable } from 'rxjs';

import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';

import { NzBadgeModule } from 'ng-zorro-antd/badge';

import { GetUnreadAlertsCount } from '@app/alerts/state/alerts-state.actions';
import { AlertsState } from '@app/alerts/state/alerts.state';

@Component({
  selector: 'adspt-alerts-center-counter',
  templateUrl: './alerts-center-counter.component.html',
  styleUrls: ['./alerts-center-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzBadgeModule, AsyncPipe, NgClass],
})
export class AlertsCenterCounterComponent {
  readonly unreadCount$: Observable<number> = this.store.select(AlertsState.unreadCount);

  @Dispatch()
  readonly getUnreadCount = () => new GetUnreadAlertsCount();

  constructor(private store: Store) {
    this.getUnreadCount();
  }
}
